// Module
var code = `<div class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree" data-bind="attr: {id: id}">
    <div class="panel-body">
        <!-- ko template: { nodes: \$componentTemplateNodes } --><!-- /ko -->
    </div>
</div>`;
// Exports
module.exports = code;